module.exports = __webpack_public_path__ + "first-50_signature.jpg?8d07025ceaef9c4bc68b89c773bf7cfd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50_signature.jpg
// module id = 575
// module chunks = 0